<template>
    <div class="message-item__content--rich-text">
        <div class="content-wrap">
            <!--
                ios 一次性插入 mock 数据时（iframe 不在视口内），iframe 不可滚动，
                根据规则，需要在视口内加载才可滚动
             -->
            <iframe
                :src="url"
                scrolling="yes"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MessageContentRichText',
        props: {
            url: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .message-item__content--rich-text {
        height: 300px;
        padding: 6px;
        background-color:  #ffffff;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        box-shadow: $primary-box-shadow;
        @include radius(.25, .5, .5, .5);

        @include desktop {
            width: 560px;
            height: 300px;
        }
    }

    .content-wrap {
        height: 100%;
    }

    iframe {
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
